export const BRAND = {
  name: "Bremer Schneemann",
  tagline: "Winterdienst in Bremen & Umgebung",
  owner: "Adil Altun",
  phone: "+49 421 16152637",
  phoneHref: "tel:+4942116152637",
  whatsapp: "https://wa.me/4915737775391",
  whatsappNumber: "+49 1573 7775391",
  email: "info@bremer-schneemann.de",
  emailHref: "mailto:info@bremer-schneemann.de",
  street: "Flughafenallee 26",
  streetExtra: "Überseeinsel / Atlantic Hotel",
  zip: "28199",
  city: "Bremen",
  fleet: "Der Fuhrpark startet aus Bremen-Hemelingen.",
  vatId: "DE450657364",
  origin: "https://www.bremer-schneemann.de",
  logo: "https://customer-assets-cm19k8pv.emergentagent.net/job_winterdienst-hb/artifacts/154048993983e509_Bremer%20Schneemann%20Winterdienst-Logo.png",
};

export const NAV = [
  { label: "Startseite", to: "/" },
  { label: "Winterdienst", to: "/winterdienst-bremen" },
  { label: "Privat", to: "/winterdienst-bremen-privat" },
  { label: "Gewerbe", to: "/winterdienst-bremen-gewerbe-hausverwaltung" },
  { label: "Leistungen", to: "/leistungen" },
  { label: "Einsatzgebiet", to: "/einsatzgebiet" },
  { label: "Über uns", to: "/ueber-uns" },
  { label: "FAQ", to: "/faq" },
  { label: "Kontakt", to: "/kontakt" },
];

export const HERO_SERVICES = [
  "Schneeräumung von Gehwegen und Zufahrten",
  "Streuen von Salz oder Sand auf Straßen und Wegen",
  "Eisbeseitigung von Treppen und Eingangsbereichen",
  "Schneeräumung von Parkplätzen und Parkhäusern",
  "Entfernung von Schneemassen an Einfahrten und Garagen",
  "24/7-Bereitschaftsdienst bei Schneefall",
  "Schneeräumung für private und gewerbliche Objekte",
];

export const IMG = {
  // Eigene Aufnahmen (Bremen, Winterdienst-Einsätze)
  gritterParking:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_winterdienst-hb/artifacts/b41eefcf36664ada_WhatsApp%20Image%202026-10-06%20at%2022.11.40.webp",
  clearedParking:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_winterdienst-hb/artifacts/7774a4f616583457_WhatsApp%20Image%202026-10-06%20at%2022.11.39%20%282%29.webp",
  clearedRamp:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_winterdienst-hb/artifacts/bddea5fff31b9b71_WhatsApp%20Image%202026-10-06%20at%2022.11.39.webp",
  snowingRamp:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_winterdienst-hb/artifacts/44e3121b01c74cb7_WhatsApp%20Image%202026-10-06%20at%2022.11.39%20%281%29.webp",
  stadtmusikanten:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_winterdienst-hb/artifacts/7c1fe5feacc41d47_ausflugsziel_bremer-stadtmusikanten_n69056-67316-1_l.jpg",
};

// Aliase, damit alle Seiten dieselben eigenen Bilder nutzen
IMG.heroStreet = IMG.gritterParking;
IMG.plowStreet = IMG.gritterParking;
IMG.parkingLot = IMG.clearedParking;
IMG.wideStreet = IMG.clearedParking;
IMG.bremenMarket = IMG.clearedParking;
IMG.houseEntrance =
  "https://images.unsplash.com/photo-1764625792087-e4bcdb96e459?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
IMG.clearedWalk = IMG.houseEntrance;
IMG.oldTownLane = IMG.clearedRamp;
IMG.bremenFacade = IMG.clearedRamp;
IMG.shovelWorker = IMG.snowingRamp;
IMG.snowyCars = IMG.snowingRamp;
IMG.nightStreet = IMG.snowingRamp;

export const DISTRICTS = [
  "Mitte",
  "Neustadt",
  "Östliche Vorstadt",
  "Schwachhausen",
  "Findorff",
  "Horn-Lehe",
  "Oberneuland",
  "Hemelingen",
  "Sebaldsbrück",
  "Vahr",
  "Osterholz",
  "Obervieland",
  "Woltmershausen",
  "Gröpelingen",
  "Walle",
  "Burglesum",
  "Vegesack",
  "Blumenthal",
  "Huchting",
  "Borgfeld",
];

export const SERVICE_INDEX = [
  { title: "Schneeräumung", to: "/schneeraeumung-bremen", desc: "Maschinelles und manuelles Räumen von Wegen, Höfen und Flächen." },
  { title: "Streudienst", to: "/streudienst-bremen", desc: "Abstumpfende und auftauende Streumittel – flächengerecht dosiert." },
  { title: "Eisbeseitigung", to: "/eisbeseitigung-bremen", desc: "Eisschichten an Treppen, Eingängen und Rampen gezielt lösen." },
  { title: "Gehwege", to: "/gehweg-winterdienst-bremen", desc: "Räum- und Streupflicht am Gehweg zuverlässig übernommen." },
  { title: "Zufahrten", to: "/zufahrten-winterdienst-bremen", desc: "Einfahrten und Hofzufahrten durchgängig befahrbar halten." },
  { title: "Parkplätze & Parkhäuser", to: "/parkplatz-winterdienst-bremen", desc: "Große Flächen, Rampen und Parkdecks im Winter sicher nutzbar." },
  { title: "Garagen & Einfahrten", to: "/garagen-winterdienst-bremen", desc: "Schneemassen vor Garagentoren und Stellplätzen entfernen." },
  { title: "Treppen & Eingänge", to: "/treppen-winterdienst-bremen", desc: "Die kritischsten Punkte am Objekt – Stufe für Stufe." },
  { title: "Gewerbeimmobilien", to: "/winterdienst-gewerbeimmobilien", desc: "Büro-, Industrie- und Handelsobjekte mit klaren Abläufen." },
  { title: "Wohnimmobilien", to: "/winterdienst-immobilien-bremen", desc: "Mehrfamilienhäuser und Verwaltungsbestand entlasten." },
  { title: "24/7-Bereitschaft", to: "/winterdienst-24-7-bremen", desc: "Bereitschaft bei Schneefall und Glätte – auch nachts." },
  { title: "Bremen & Umgebung", to: "/winterdienst-bremen-umgebung", desc: "Stadtgebiet Bremen und das direkte Umland." },
];
